import { Content } from '@next-app/interface/Common';

interface JSONProps {
  contentItem: Content;
}

export default function JSON(props: JSONProps) {
  return <span className="hidden">{props.contentItem.content}</span>;
}
